<template>
  <div class="dashboard-item">
    <div class=" d-flex align-items-center dashboard-item__header">
      <h4 class="border-none m-0 p-0">Hot Leads</h4>
      <small-spinner v-if="ui.loading"/>
    </div>
    <div class="list">
      <div class="row">
        <div class="col-4">Lead</div>
        <div class="col-4">Source</div>
        <div class="col">Notes</div>
        <div class="col"></div>
      </div>
      <div class="dashboard-item__body scrollable" id="hot-lead">
        <div class="row" v-for="(lead, index) in hotLeads" :key="index">
          <div class="col-4 my-auto">
            <router-link
              :to="{ name: 'lead_info', params: { id: lead.uuid } }"
              class="lead-links"
            >
              {{ lead.leads }}
            </router-link>
          </div>
          <div class="col-4 my-auto of-hidden">
            {{ lead.type }}
          </div>
          <div class="col my-auto">
            <button @click="showNotes(lead.uuid, lead.leads)"
                    class="btn-note"
                    content="Show Notes" v-tippy="{ placement : 'bottom',  arrow: true }">
              <img src="@/assets/images/icons/icon-notes.svg" alt="Notes"/>
            </button>
          </div>
          <div class="col text-right dsb-date my-auto">
            {{ lead.createdShort }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SmallSpinner from "../../../components/SmallSpinner";

export default {
  name: 'HotLeadsItems',
  components: {SmallSpinner},
  data() {
    return {
      hotLeads: [],
      ui: {
        loading: false,
      }
    }
  },
  beforeMount() {
    this.getHotLeads();
  },
  methods: {
    getHotLeads() {
      this.ui.loading = true
      this.$http
        .get('/api/v1/leads', {
          params: {
            status: 'Hot Leads',
          },
        })
        .then((res) => (this.hotLeads = res.data.data))
        .catch((err) => console.log(err))
        .finally(() => this.ui.loading = false)

    },
    showNotes(id, name) {
      this.$emit('showNotes', {id, name});
    }
  }
}
</script>
